import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLocationMarkerinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [/* @__PURE__ */ _jsx("path", { d: "M32 52.3s17-19.93 17-32.956C49 10.318 41.389 3 32 3s-17 7.318-17 16.344C15 32.371 32 52.3 32 52.3z" }), /* @__PURE__ */ _jsx("path", { d: "M42.917 46H47l10 13H6l10-13h4.905M32 24a5 5 0 1 0 0-10 5 5 0 0 0 0 10z" })]
	})
});
export default SvgLocationMarkerinline;
